import { tryGet } from './index';

export const getFeatureFlags = async () => {
  const result = await tryGet(`/featureFlags`);
  return result?.data ?? [];
};